import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Zone from '../../entities/admin/zone'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface ZoneState extends ListState<Zone>{
    editModel:Zone;
    
}
class ZoneModule extends ListModule<ZoneState,any,Zone>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Zone>(),
        loading:false,
        editModel: new Zone(),
        activeList: new Array<Zone>(),
        path: 'zones'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions        
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const zoneModule=new ZoneModule();
export default zoneModule;
